<template>
  <div class="kp-modular-row clearfix">
    <label class="kp-modular-label">{{$t('edit.sidebar.font')}}</label>
    <select
      @change="onChange($event)"
      class="klickart-select">
      <option
        v-for="font in fontFamilies"
        :value="font.value"
        :selected="font.value === stepStyle(item).fontFamily"
        >{{ font.label }}</option>
    </select>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: [
    'item',
    'general',
  ],
  data() {
    return {
      fontFamilies: [
        { value: '', label: 'Padrão' },
        { value: 'Arial, Helvetica Neue, Helvetica, sans-serif', label: 'Arial' },
        { value: 'Comic Sans MS, cursive, sans-serif', label: 'Comic Sans MS' },
        { value: 'Courier New, Courier, monospace', label: 'Courier New' },
        { value: 'Georgia, serif', label: 'Georgia' },
        { value: 'Lucida Sans Unicode, Lucida Grande, sans-serif', label: 'Lucida Sans Unicode' },
        { value: 'Tahoma, Geneva, sans-serif', label: 'Tahoma' },
        { value: 'Times New Roman, Times, serif', label: 'Times New Roman' },
        { value: 'Trebuchet MS, Helvetica, sans-serif', label: 'Trebuchet MS' },
        { value: 'Verdana, Geneva, sans-serif', label: 'Verdana' },
      ],
    };
  },
  methods: {
    onChange(event) {
      const { value } = event.target;

      if (this.general) {
        return this.quizUpdateStyle({ item: this.item, rule: 'fontFamily', value });
      }

      return this.stepUpdateStyle({ item: this.item, rule: 'fontFamily', value });
    },
    ...mapActions([
      'quizUpdateStyle',
      'stepUpdateStyle',
    ]),
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** FontFamily.vue?31a82074
 **/